import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./firebase";

const allowedEmails = ["dipeshbalodiya3@gmail.com", "umangsharma122005@gmail.com"];

const AdminPanel = () => {
    const [teams, setTeams] = useState([]);
    const [userEmail, setUserEmail] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is authorized
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user || !allowedEmails.includes(user.email)) {
                navigate("/"); // Redirect unauthorized users
            } else {
                setUserEmail(user.email);
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    useEffect(() => {
        if (userEmail) {
            const teamsRef = collection(db, "teams");

            // Real-time listener for Firestore changes
            const unsubscribe = onSnapshot(teamsRef, (snapshot) => {
                const teamsData = snapshot.docs.map((doc, index) => ({
                    id: doc.id,
                    serialNumber: index + 1,
                    ...doc.data()
                }));
                setTeams(teamsData);
            });

            return () => unsubscribe(); // Cleanup listener when component unmounts
        }
    }, [userEmail]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
            <h2 className="text-2xl font-bold text-blue-700 mb-4">Admin Panel - Attendance</h2>
            
            <div className="bg-white p-4 rounded shadow-md w-full max-w-6xl overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300">
                    <thead>
                        <tr className="bg-blue-500 text-white">
                            <th className="border p-2">S.No</th>
                            <th className="border p-2">Team Name</th>
                            <th className="border p-2">Leader</th>
                            <th className="border p-2">Leader Attendance</th>
                            <th className="border p-2">Email</th>
                            <th className="border p-2">Contact</th>
                            <th className="border p-2">Project Theme</th>
                            <th className="border p-2">Project Type</th>
                            <th className="border p-2 w-1/3">Members Attendance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teams.map(team => (
                            <tr key={team.id} className="border text-center">
                                <td className="border p-2">{team.serialNumber}</td>
                                <td className="border p-2">{team.teamName}</td>
                                <td className="border p-2">{team.teamLeaderSalutation} {team.teamLeaderName}</td>
                                <td className={`border p-2 font-bold ${team.teamLeaderAttendance ? "text-green-500" : "text-red-500"}`}>
                                    {team.teamLeaderAttendance ? "Present" : "Absent"}
                                </td>
                                <td className="border p-2">{team.email}</td>
                                <td className="border p-2">{team.contactNumber || "N/A"}</td>
                                <td className="border p-2">{team.theme || "N/A"}</td>
                                <td className="border p-2">{team.type || "N/A"}</td>
                                <td className="border p-2 text-left w-1/3">
                                    {team.teamMembers ? (
                                        <ul>
                                            {team.teamMembers.map(member => (
                                                <li key={member.name} className={member.attendance ? "text-green-500" : "text-red-500"}>
                                                    {member.name} - {member.attendance ? "Present" : "Absent"}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : "No members"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminPanel;
